export interface ITokenizedCreditCardData {
  encryptedSecurityCode: string;
  encryptedExpiryMonth: string;
  encryptedExpiryYear: string;
  encryptedCardNumber: string;
}

export interface IBillingCardAddress {
  postalCode: string;
  countryCode: string;
}

export function buildTokenizedCreditCardData(): ITokenizedCreditCardData {
  return {
    encryptedSecurityCode: '',
    encryptedExpiryMonth: '',
    encryptedExpiryYear: '',
    encryptedCardNumber: '',
  };
}

export function buildBillingCardAddress(): IBillingCardAddress {
  return {
    countryCode: '',
    postalCode: '',
  };
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/card_data.ts